import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import Admin from "apis/Admin";

// First, create the thunk
export const getInfo = createAsyncThunk("getInfo", async () => {
  const response = await Admin.get("totalCounts");
  return response.data.data;
});

// Then, handle actions in your reducers:
const getInfoSlice = createSlice({
  name: "getInfo",
  initialState: {
    totalAlbums: 0,
    totalArtists: 0,
    totalPaymentCollected: 0,
    totalArtistPayment: 0,
    totalPlactronPayment: 0,
    totalPosts: 0,
    totalSongs: 0,
    totalSubscription: 0,
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [getInfo.fulfilled]: (state, action) => {
      return {...state ,...action.payload};
    },
  },
});

export default getInfoSlice.reducer;
